import { CHECK_HASH_SUCCESS } from '../actions/registration.action';
import { DELETE_EMPLOYEES } from '../actions/password.actions';
import { FETCH_EMPLOYEE_DATA, EDIT_EMPLOYEE_LANGUAGE } from '../actions/employee.action';
import { SET_NOTIFICATIONS } from '../actions/notification.actions';
import { RESET_STATE } from '../actions/common.actions';

export const employee = (state = {}, action) => {
  switch (action.type) {
    case CHECK_HASH_SUCCESS:
      return action.payload;

    case FETCH_EMPLOYEE_DATA:
      return action.payload;

    case DELETE_EMPLOYEES:
      return {};

    case SET_NOTIFICATIONS:
      return { ...state, notifications: action.payload };

    case EDIT_EMPLOYEE_LANGUAGE:
      return { ...state, language: action.payload };

    case RESET_STATE:
      return {};

    default:
      return state;
  }
};
